import { CustomizationFlagStatesV2 } from 'models/location-feature.model';
import { SalesforceAccountProductBundle } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';

export { SalesforceAccountProductBundle };

export enum IntegrationPackagesEnum {
  PLUS = 'PLUS',
  CORE = 'CORE',
}

export enum BundlePackagesEnum {
  ULTIMATE = 'ULTIMATE',
  ELITE = 'ELITE',
  PRO = 'PRO',
  ESSENTIALS = 'ESSENTIALS',
}

export type CustomizationFlag = {
  name?: string;
  id?: string;
  state?: CustomizationFlagStatesV2;
};

export type ProhibitedFlags = {
  name?: string;
  id?: string;
};

export type {
  CustomizationFlagsRequest,
  CustomizationFlagsResponse,
} from '@weave/schema-gen-ts/dist/schemas/package-service/v1/package.pb';
